import styled from "styled-components";
import { MainCorrect, MainDashedInput, MainFrame, MainFrameWrapper, MainHeading, MainHeadingColor, MainQuestion, MainSection, MainSectionWrapper, MainSentenceWrapper } from "../../components/01_config/MainStyles";
import { sizes } from "../../components/01_config/Sizes";
import { colors } from "../../components/01_config/Colors";

const Wrapper = styled.div`
    position: relative;
    margin: ${sizes.headerheight} ${sizes.margins_desk} 0;
    background-color: #EBEBEB;
    border-bottom: solid 2px white;
    display: flex;
    flex-direction: column;
    // gap: ${sizes.marginsections};
    // padding-bottom: ${sizes.marginsections};
    @media(max-width: 800px) {
        margin: ${sizes.headerhight_mobile} 0 0;
        
    }
`

const Header = styled.div`
    position: relative;
    padding: 50px;
    background-color: ${colors.reading};
    color: white;
    font-size: 3rem;
    font-weight: bold;
    text-transform: uppercase;
    @media(max-width: 800px) {
        padding: 30px 0;
        text-align: center;
        font-size: 2rem
    }
`

const HeadingSection = styled(MainHeading)`
    text-align: center;
`

const FrameWrapper = styled(MainFrameWrapper)`

`

const TextsSection = styled(MainSection)`
    flex-direction: column;
    scroll-margin-top: ${sizes.headerheight};
`

const HeadingColor = styled(MainHeadingColor)`
    text-align: center;
`

const Frame = styled(MainFrame)`
    display: flex;
    flex-direction: column;
`

const ImageAudioWrapper = styled.div`
`

const Image = styled.img`
    height: 200px;
    width: 200px;
    object-fit: cover;
    margin: 0 auto;
`

const SentenceWrapper = styled(MainSentenceWrapper)`
    text-align: center;
    align-items: center;
`

const Question = styled(MainQuestion)`
    white-space: pre-wrap;
    line-height: 1.1;
`

const ListeningInput = styled(MainDashedInput)`

`

const Correct = styled(MainCorrect)`
    color: red;
    font-size: 1rem;
    line-height: 1;
`

const TopicWrapper = styled.div`
    display: flex;
    justify-content: center;
        line-height: 2;
`

const TopicLabel = styled.div`
    font-weight: bold;
`

const Topic = styled.div`
    text-decoration: underline;
    white-space: pre-wrap;
`


export { Wrapper, Header, HeadingSection, FrameWrapper, TextsSection, HeadingColor, Frame, ImageAudioWrapper, Image, SentenceWrapper, Question, ListeningInput, Correct, TopicWrapper, TopicLabel, Topic }